export default "__VITE_ASSET__B431KIOH__"